import React, { useState, useEffect } from "react";
import { FaBullseye, FaLock, FaBolt, FaLightbulb } from "react-icons/fa";   
  

const WhoWeAre = () => {
  const [isVisible, setIsVisible] = useState(false);

  const highlights = [
    {
      icon: <FaBullseye/>,
      title: "Customer-Centric",
      description: "We put our customers first in every decision we make",
    },
    {
      icon: <FaLock/>,
      title: "Trust & Safety",
      description: "Every professional is verified and background-checked",
    },
    {
      icon: <FaBolt/>,
      title: "Quick & Reliable",
      description: "Fast service delivery with quality guaranteed",
    },
    {
      icon: <FaLightbulb/>,
      title: "Innovation",
      description: "Using technology to make home services seamless",
    },
  ];

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 300);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="who-we-are-section">
      <div className="who-we-are-container">
        {/* Section Header */}
        <div className={`who-we-are-header ${isVisible ? "who-fade-in" : ""}`}>
          <div className="who-section-badge">
            <span className="who-badge-icon">👥</span>
            <span className="who-badge-text">WHO WE ARE</span>
          </div>
          <h2 className="who-section-title">
            USA's Leading Home Service Platform
          </h2>
          <p className="who-section-subtitle">
            Connecting homeowners with trusted professionals since 2020
          </p>
        </div>

        {/* Main Content Grid */}
        <div className="who-content-grid">
          {/* Left Side - Image & Badge */}
          <div className={`who-image-section ${isVisible ? "who-slide-left" : ""}`}>
            <div className="who-image-wrapper">
              <img
                src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=800&h=900&fit=crop"
                alt="WorkHub Team"
                className="who-main-image"
              />
            </div>
          </div>

          {/* Right Side - Content */}
          <div className={`who-text-section ${isVisible ? "who-slide-right" : ""}`}>
            <div className="who-text-content">
              <p className="who-description">
                <strong>WorkHub</strong> is USA's most trusted platform for home services. We bridge the gap
                between homeowners seeking quality service and skilled professionals looking to grow their business.
              </p>

              <p className="who-description">
                Founded with a mission to revolutionize the home service industry, we've created an ecosystem where
                trust, quality, and convenience come together. Our platform serves thousands of customers across major
                cities, providing everything from electrical work to home cleaning.
              </p>

              <div className="who-highlights-grid">
                {highlights.map((item, index) => (
                  <div key={index} className="who-highlight-item">
                    <div className="who-highlight-icon">{item.icon}</div>
                    <div className="who-highlight-content">
                      <h4 className="who-highlight-title">{item.title}</h4>
                      <p className="who-highlight-text">{item.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhoWeAre;